class OrderInformationTipsController {
    constructor(settings) {
        this.settings = settings;
    }
}

OrderInformationTipsController.$inject = ['Settings'];

const orderInformationTipsComponentDefinition = {
    bindings: {
        orderMethod: '<',
    },
    controller: OrderInformationTipsController,
    template: require('./order-information-tips.component.html').trim(),
};

module.exports = {
    OrderInformationTipsController,
    orderInformationTipsComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/orderinformation/order-information-tips.component.js